import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  edit?: boolean;
  minWidth?: string;
}

export const Root = styled.div`
`

export const Row = styled.div`
  max-width: ${(props: IProps) => (props.edit ?  `unset` : `550px`)};
  flex-wrap: wrap;
  display: flex;
  justify-content: ${(props: IProps) => (props.edit ?  `unset` : `space-between`)};
  gap: 20px;
  min-width: ${(props: IProps) => (props.minWidth)};
  margin-bottom: 35px;
`